import { forwardRef } from "react";

function Root(props, ref) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M22 7.81V16.18C22 19.82 19.83 21.99 16.19 21.99H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.18C19.83 2 22 4.17 22 7.81Z"
        fill="#fff"
      />
      <path
        d="M12.53 5.47L16.82 9.76C17.11 10.05 17.11 10.53 16.82 10.82C16.53 11.11 16.05 11.11 15.76 10.82L12.75 7.81V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V7.81L8.24001 10.82C7.95001 11.11 7.47001 11.11 7.18001 10.82C7.03001 10.67 6.96001 10.48 6.96001 10.29C6.96001 10.1 7.04001 9.9 7.18001 9.76L11.47 5.47C11.61 5.33 11.8 5.25 12 5.25C12.2 5.25 12.39 5.33 12.53 5.47Z"
        fill="#12a9b2"
      />
    </svg>
  );
}
const UpArrow = forwardRef(Root);
export default UpArrow;
